/* The outline card: board O's rows (a line's span on the right), board M's flow. */

.card {
  display: flex;
  flex-direction: column;
  outline: none;
}

.eyebrow {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  margin: var(--space-0);
  padding: var(--space-14px) var(--space-18px) var(--space-0);
  font-size: var(--fs-note);
  font-weight: var(--fw-regular);
  color: var(--text-2);
}

.eyebrowGlyph {
  width: 15px;
  height: 15px;
}

.title {
  margin: var(--space-0);
  padding: var(--space-2) var(--space-18px) var(--space-1);
  font-size: var(--fs-mode);
  font-weight: var(--fw-semibold);
  letter-spacing: var(--ls-title);
}

.meta {
  margin: var(--space-0);
  padding: var(--space-0) var(--space-18px) var(--space-10px);
  font-size: var(--fs-note);
  font-weight: var(--fw-regular);
  color: var(--text-2);
}

.cycles {
  display: flex;
  flex-direction: column;
  padding: var(--space-1) var(--space-18px) var(--space-6px);
  list-style: none;
}

.cycle {
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr) auto;
  gap: var(--space-1) var(--space-3);
  padding: var(--space-10px) var(--space-0);
  border-top: var(--border-hairline) solid var(--border);
}

.cycle:first-child {
  border-top: 0;
}

.bullet {
  width: 14px;
  height: 14px;
  margin-top: var(--space-3px);
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-buddy-ring);
}

.bulletLight {
  background: var(--buddy-hatch);
  box-shadow: var(--shadow-buddy-ring-light);
}

.cycleTitle {
  font-size: var(--fs-body);
  font-weight: var(--fw-medium);
  letter-spacing: var(--ls-heading);
}

.cycleSpan {
  font-size: var(--fs-label);
  font-weight: var(--fw-medium);
  color: var(--text-2);
  white-space: nowrap;
}

.cycleDetail {
  grid-column: 2 / span 2;
  font-size: var(--fs-note);
  line-height: var(--lh-relaxed);
  color: var(--text-2);
}

.more {
  display: flex;
  justify-content: center;
  padding: var(--space-2px) var(--space-0) var(--space-10px);
}

.moreButton {
  display: inline-flex;
  gap: var(--space-5px);
  align-items: center;
  padding: var(--space-0);
  font-family: var(--font-body);
  font-size: var(--fs-note);
  font-weight: var(--fw-medium);
  color: var(--text-2);
  cursor: pointer;
  background: transparent;
  border: 0;
}

.moreButton:focus-visible {
  outline: var(--border-focus) solid var(--focus);
  outline-offset: var(--space-2px);
}

.moreGlyph {
  width: 12px;
  height: 12px;
}

.moreGlyphUp {
  transform: rotate(180deg);
}

.assumptions {
  padding: var(--space-0) var(--space-18px) var(--space-14px);
}

.foot {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  justify-content: flex-end;
  padding: var(--space-3) var(--space-14px);
  border-top: var(--border-hairline) solid var(--border);
}

.hint {
  flex: 1;
  min-width: 0;
  font-size: var(--fs-label);
  font-weight: var(--fw-regular);
  color: var(--text-2);
}
